import { render, staticRenderFns } from "./InputSubmit.vue?vue&type=template&id=77760f48&scoped=true&"
import script from "./InputSubmit.vue?vue&type=script&lang=js&"
export * from "./InputSubmit.vue?vue&type=script&lang=js&"
import style0 from "./InputSubmit.vue?vue&type=style&index=0&id=77760f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77760f48",
  null
  
)

export default component.exports